/** Vite exposes only variables prefixed with VITE_
 * https://vite.dev/guide/env-and-mode
 */
export const ENV_CONFIG = {
	BASE_API_UTL: import.meta.env.VITE_API_URL,
	BASE_SOCKET_URL: import.meta.env.VITE_SOCKET_API_URL,
	BASE_HUB_URL: import.meta.env.VITE_HUB_API_URL,
	BASE_MESSENGER_URL_SERVER: import.meta.env.VITE_MESSENGER_BASE_URL_SERVER,
	BASE_MESSENGER_URL_WS: import.meta.env.VITE_MESSENGER_BASE_URL_WS,
	BASE_BUCKET_URL: import.meta.env.VITE_BUCKET_BASE_URL,
	BASE_URL_BANNER: import.meta.env.VITE_BASE_URL_BANNER,
	BANNER_CACHE_INVALIDATION_INTERVAL: import.meta.env.VITE_BANNER_CACHE_INVALIDATION_INTERVAL,
	DREAMCAM_LINK: import.meta.env.VITE_DREAMCAM_LINK,
	APP_ENV: import.meta.env.VITE_APP_ENV,
	JSM_SECRET_KEY: import.meta.env.VITE_JSM_SECRET_KEY,
	PROJECT_NAME_ENV: import.meta.env.VITE_PROJECT_NAME_ENV,
	VR_VIDEO_LINK_FORM: import.meta.env.VITE_VR_VIDEO_LINK_FORM,
	SHOW_INTRO_LOGO: import.meta.env.VITE_SHOW_INTRO_LOGO,
	RECAPTCHA_KEY: import.meta.env.VITE_RECAPTCHA_KEY,
	CLOUDFLARE_SITE_KEY: import.meta.env.VITE_CLOUDFLARE_SITE_KEY,
	SIGNUP_FORM_MODE: import.meta.env.VITE_SIGNUP_FORM_MODE,
	TOYS_GATE_URL: import.meta.env.VITE_TOYS_GATE_URL,
} as const;
